import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles(() => ({
  panelFooterContainer: {
    display: "flex",
    height: ({
      gutterTop
    }) => gutterTop ? 75 : 60,
    paddingTop: ({
      gutterTop
    }) => gutterTop ? 10 : 0
  },
  footer: {
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center"
  },
  buttonContainer: {
    display: "flex",
    marginLeft: "auto",
    "& > :first-child": {
      marginRight: ({
        rightSpacing
      }) => rightSpacing ? rightSpacing : 16
    }
  }
}));
const ConversationPanelContainer = ({
  children,
  gutterTop = false,
  rightSpacing
}) => {
  const classes = useStyles({
    gutterTop,
    rightSpacing
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.panelFooterContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, children)));
};
export default ConversationPanelContainer;
ConversationPanelContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  gutterTop: PropTypes.bool,
  rightSpacing: PropTypes.number
};